// extracted by mini-css-extract-plugin
export default {"about":"About_about__LBKT9","header_dark":"About_header_dark__otIX7","row":"About_row__xxaS8","col":"About_col__GpeqC"};